<template>
  <div class="flex items-center">
    <h2
      class="capitalize leading-normal text-2xl border-l-4 pl-2 mb-2"
      :class="[color, borderColor]"
    >
      <slot />
    </h2>
    <div class="flex-1" />
    <div :class="[hide && 'hidden']">
      <div class="flex items-center md:block hidden text-center">
        <p>Manage</p>
        <span
          class="mx-2 cursor-pointer"
          @click="setView('grid')"
          id="grid-view"
          data-tippy-content="grid view"
          ><i
            class="fas fa-th"
            :class="[view === 'grid' ? 'text-blue-500' : 'text-white']"
          ></i
        ></span>
        <span
          class="mx-2 cursor-pointer"
          @click="setView('list')"
          id="list-view"
          data-tippy-content="list view"
          ><i
            class="fas fa-th-list"
            :class="[view === 'list' ? 'text-blue-500' : 'text-white']"
          ></i
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import tippy from "tippy.js";
export default {
  name: "subtitle",
  props: {
    color: {
      type: String,
      default: "text-yellow-600"
    },
    borderColor: String
  },
  setup() {
    const route = useRoute();
    const hide = ref(false);
    const { dispatch, state } = useStore();
    let view = computed(() => state.view);

    tippy("#grid-view");
    tippy("#list-view");

    onMounted(() => {
      if (route.path === "/search") {
        hide.value = true;
      }
    });

    const setView = val => {
      dispatch("setView", val);
    };
    return { setView, view, hide };
  }
};
</script>
